export default __webpack_public_path__ + "static/media/annual_expenditure_icon.b503afe2.svg";